// import { lt } from 'semver';
// import goodsApi from '@/api/masterData/goods.js';
export default {
  data() {
    return {
      // projectStatusList: [],
      // goodsTypeList: [], // 货物品类
      // goodsCategoryList: [], // 获取类型
    };
  },
  methods: {
    async getDict(dictType) {
      if (this.dictList != null) {
        let dict1 = this.dictList.find((it) => it.dictType == dictType);
        if (dict1 != null) {
          return dict1.dictList;
        } else {
          let list = this.$baseRequest.getDictListMapByType(dictType);
          if (list) {
            return list;
          }
        }
      }
      return [];
    },
    getProjectSourceType(code) {
      let name = '';
      switch (code) {
        case 'SWQT':
          name = '商务洽谈';
          break;
        case 'TB':
          name = '投标';
          break;
        case 'OT':
          name = '其他';
          break;
        default:
          break;
      }
      return name;
    },
    getStatusName(statusCode) {
      if (statusCode == 'ZT01') {
        return '草稿';
      } else if (statusCode == 'ZT02') {
        return '已作废';
      } else if (statusCode == 'ZT03') {
        return '审批中';
      } else if (statusCode == 'ZT04') {
        return '审批通过';
      } else if (statusCode == 'ZT05') {
        return '项目执行中';
      } else if (statusCode == 'ZT06') {
        return '审批驳回';
      }
    },
  },
  mounted() {
    // this.getGoodsParentApi(); // 获取商品大类
  },
};
